




















































































































































































































import Vue from "vue";
import moment from "moment";

// components
import DeviceTreeAppPage from "@/components/DeviceTreeAppPage.vue";
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";
import TransactionFilterCard from "./TransactionFilterCard.vue";
import TransactionTotalValueCard from "./TransactionTotalValueCard.vue";
import TransactionDetails from "./TransactionDetails.vue";
import InOutTransactionDetails from "./InOutTransactionDetails.vue";
import UserBalanceTransactionDetails from "./UserBalanceTransactionDetails.vue";

// Model
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";
import { TransactionTypeEnum, transactionTypeEnumLabel } from "@/model/data/enums/TransactionTypeEnum";
import { transactionSubtypeEnumLabel } from "@/model/data/enums/TransactionSubtypeEnum";
import { GetTransactionListReqData } from "@/model/communication/cashReport/GetTransactionListReqData";
import { ExportTransactionsReqData } from "@/model/communication/cashReport/ExportTransactionsReqData";
import { TransactionsFilterData } from "@/model/communication/cashReport/TransactionsFilterData";
import { GetTransactionListCommand } from "@/model/communication/cashReport/GetTransactionListCommand";
import { GetTransactionTotalsCommand } from "@/model/communication/cashReport/GetTransactionTotalsCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { DownloadCashReportCommand } from "@/model/communication/cashReport/DownloadCashReportCommand";
import { GetIntegrationFeedbackResultEnumLabel, IntegrationFeedbackResultEnum, IntegrationFeedback } from "@/model/data/cashFlow/IntegrationFeedback";

// utility
import { formatCurrency } from "@/utility/Formatter";
import { dataTableItemsPerPage, MODULE_COLORS } from "@/utility/Constants";
import { CashReportUserLongTaskInputData } from "@/model/data/userLongTasks/CashReportUserLongTaskInputData";
import { CreateCashReportLongTaskCommand } from "@/model/communication/userLongTasks/CreateCashReportLongTaskCommand";
import router from "@/router";
import * as RR from "@/router/routes";
import { mapGetters } from "vuex";

const MAX_TRANSACTION_PER_REAL_TIME_EXPORT = 5000;

export default Vue.extend({
    components: {
        DeviceTreeAppPage,
        TransactionFilterCard,
        TransactionTotalValueCard,
        TransactionDetails,
        InOutTransactionDetails,
        UserBalanceTransactionDetails,
        ColumnVisibilityFilter,
    },
    data() {
        return {
            MODULE_COLORS,
            moment,
            TransactionTypeEnum,
            dataTableItemsPerPage,
            IntegrationFeedbackResultEnum,

            longTaskDialog: false,
            exportWithLongTask: false,

            transactionsFilterData: new TransactionsFilterData(),
            deviceTreeSelectedObjectItems: [],

            dataTableLoading: false,
            downloadLoading: false,
            totalsLoading: false,

            transactionTotals: [],
            transactions: [],
            totalTransactionsLength: 0,

            options: {},
            availableHeaders: [],
            initialAvailableHeaders: [
                { enabled: true, text: this.$t("common.installationName"), value: "installationName" },
                { enabled: false, text: this.$t("common.transactionId"), value: "nop" },
                { enabled: true, text: this.$t("common.dateTime"), value: "dateTime" },
                { enabled: true, text: this.$t("common.userId"), value: "userId" },
                { enabled: false, text: this.$t("cash_report.user_info"), value: "userInfo" },
                { enabled: false, text: this.$t("cash_report.user_organization"), value: "userOrganization" },
                { enabled: true, text: this.$t("common.type"), value: "type" },
                { enabled: false, text: this.$t("common.bagId"), value: "machineBags" },
                { enabled: false, text: this.$t("cash_report.channel"), value: "channelId" },
                { enabled: false, text: this.$t("branchReport.paymentsExpectedAmount"), value: "extraFeatures.paymentsExpectedAmount" },
                { enabled: false, text: this.$t("branchReport.notPaidChange"), value: "extraFeatures.notPaidChange" },
                { enabled: false, text: this.$t("common.integrations"), value: "integrationsFeedbacks", sortable: false },
                { enabled: false, text: this.$t("common.info"), value: "info" },
                { enabled: false, text: this.$t("cash_report.transaction_ref"), value: "transactionRef" },
                { enabled: false, text: this.$t("common.shift_number"), value: "shiftNumber" },
                { enabled: false, text: this.$t("cash_report.envelopeId"), value: "envelopesInfo" },
                { enabled: true, text: this.$t("common.total"), value: "total", sortable: false },
            ],

            prevIcon: "fas fa-chevron-left",
            nextIcon: "fas fa-chevron-right",
            exportType: "csv",
            hideExportType: false,
        };
    },
    watch: {
        totalTransactionsLength(val: number) {
            this.exportWithLongTask = val > MAX_TRANSACTION_PER_REAL_TIME_EXPORT;
        },
        dataTableLoading(newVal) {
            if (!newVal) {
                this.prevIcon = "fas fa-chevron-left";
                this.nextIcon = "fas fa-chevron-right";
            }
        },
        options(newOptions, oldOptions) {
            if (oldOptions != null) {
                if (newOptions.page < oldOptions.page) this.prevIcon = "fas fa-circle-notch fa-spin";
                if (newOptions.page > oldOptions.page) this.nextIcon = "fas fa-circle-notch fa-spin";
            }
        },
    },
    computed: {
        ...mapGetters(["longDateFormat"]),
    },
    methods: {
        GetIntegrationFeedbackResultEnumLabel,
        transactionTypeEnumLabel,
        transactionSubtypeEnumLabel,
        fetchDataFromSubmit() {
            if (this.options.page != 1) {
                this.options.page = 1;
            }
            this.fetchData();
        },
        fetchData() {
            this.hideExportType = false;
            this.exportType = "csv";
            if (!this.transactionsFilterData.serialNumber && moment(this.transactionsFilterData.endDate).diff(this.transactionsFilterData.startDate, "days") > 30) {
                // create report in background
                this.longTaskDialog = true;
                this.exportWithLongTask = true;
            } else {
                this.fetchTransactions();
                this.fetchTransactionsTotals();
            }
        },
        async fetchTransactions() {
            this.dataTableLoading = true;

            let reqData = new GetTransactionListReqData();

            // pagination
            reqData.offset = (this.options.page - 1) * this.options.itemsPerPage;
            reqData.queryLimit = this.options.itemsPerPage;
            reqData.orderBy = this.options.sortBy;
            reqData.orderByDescending = this.options.sortDesc;

            // device filters
            if (this.deviceTreeSelectedObjectItems && this.deviceTreeSelectedObjectItems.length) {
                reqData.installationNames = this.deviceTreeSelectedObjectItems.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).map((c) => c.id);
                reqData.folderIds = this.deviceTreeSelectedObjectItems.filter((c) => c.type == DeviceTreeNodeTypeEnum.Folder).map((c) => c.id);
            }
            // other filters
            reqData.fillFromTransactionsFilterData(this.transactionsFilterData);
            const index = reqData.orderBy.indexOf("AccountingDate");
            if (index > -1) {
                reqData.orderBy.splice(index, 1);
                reqData.orderByDescending.splice(index, 1);
            }
            if (this.transactionsFilterData && this.transactionsFilterData.dateFilterType == 1) {
                reqData.orderBy.push("AccountingDate");
                if (reqData.orderBy.indexOf("dateTime") > -1) reqData.orderByDescending.push(reqData.orderByDescending[reqData.orderBy.indexOf("dateTime")]);
                else reqData.orderByDescending.push(false);
            }
            let response = await new GetTransactionListCommand(reqData).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                this.transactions = response.transactions;
                this.totalTransactionsLength = response.paginatedTotalItems;
            }

            this.dataTableLoading = false;
        },
        async fetchTransactionsTotals() {
            this.totalsLoading = true;

            let reqData = new GetTransactionListReqData();

            // pagination
            reqData.offset = (this.options.page - 1) * this.options.itemsPerPage;
            reqData.queryLimit = this.options.itemsPerPage;
            reqData.orderBy = this.options.sortBy;
            reqData.orderByDescending = this.options.sortDesc;

            // device filters
            if (this.deviceTreeSelectedObjectItems && this.deviceTreeSelectedObjectItems.length) {
                reqData.installationNames = this.deviceTreeSelectedObjectItems.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).map((c) => c.id);
                reqData.folderIds = this.deviceTreeSelectedObjectItems.filter((c) => c.type == DeviceTreeNodeTypeEnum.Folder).map((c) => c.id);
            }

            // other filters
            reqData.fillFromTransactionsFilterData(this.transactionsFilterData);

            // response totals
            let responseTotals = await new GetTransactionTotalsCommand(reqData).execute();
            if (responseTotals.responseStatus == ApiResponseStatusEnum.Success) {
                this.transactionTotals = responseTotals.balances;
            }

            this.totalsLoading = false;
        },
        getFlowColor(v) {
            switch (v) {
                case 0:
                    return "success";
                case 1:
                    return "error";
                case 2:
                    return "info";
                default:
                    return null;
            }
        },
        getFlowIcon(v) {
            switch (v) {
                case 0:
                    return "sign-in-alt";
                case 1:
                    return "sign-out-alt";
                case 2:
                    return "exchange-alt";
                default:
                    return null;
            }
        },
        getIntegrationsIcon(integrations: IntegrationFeedback[]) {
            if (integrations.length == 0 || integrations.map((c) => c.result).every((c) => c == IntegrationFeedbackResultEnum.NotToSend)) return "minus";
            else return "check";
        },
        getIntegrationsIconColor(integrations: IntegrationFeedback[]) {
            if (integrations.length == 0 || integrations.map((c) => c.result).every((c) => c == IntegrationFeedbackResultEnum.NotToSend)) return "gray";
            else if (integrations.map((c) => c.timestamp).every((c) => c != null)) return "success";
            else return "warning";
        },
        getIntegrationsTooltipMessage(integrations: IntegrationFeedback[]) {
            let message = "";
            if (integrations.length == 0) message = this.$t("cash_report.no_integration_enabled");
            else if (integrations.map((c) => c.result).every((c) => c == IntegrationFeedbackResultEnum.NotToSend))
                message += this.$t(GetIntegrationFeedbackResultEnumLabel(IntegrationFeedbackResultEnum.NotToSend));
            else {
                integrations.forEach((i) => {
                    message += i.integrationName != null ? i.integrationName : i.integration.name + " ";
                });
            }

            return message;
        },
        getIntegrationColor(v) {
            const values = v.map((c) => c.Timestamp != null);
            if (values.every((c) => c === true)) return "success";
            else if (values.every((c) => c === false)) return "error";
            else return "warning";
        },
        async exportAs(type) {
            this.downloadLoading = true;
            try {
                let reqData = new ExportTransactionsReqData();

                // device filters
                if (this.deviceTreeSelectedObjectItems && this.deviceTreeSelectedObjectItems.length) {
                    reqData.installationNames = this.deviceTreeSelectedObjectItems.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).map((c) => c.id);
                    reqData.folderIds = this.deviceTreeSelectedObjectItems.filter((c) => c.type == DeviceTreeNodeTypeEnum.Folder).map((c) => c.id);
                }

                // other filters
                reqData.fillFromTransactionsFilterData(this.transactionsFilterData);
                reqData.columns = this.availableHeaders.filter((h) => h.enabled).map((h) => h.value);
                const res = await new DownloadCashReportCommand(type, reqData).execute();

                let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                let fileLink = document.createElement("a");
                fileLink.href = fileURL;
                fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                document.body.appendChild(fileLink);
                fileLink.click();
                this.downloadLoading = false;
            } catch (e) {
                console.log("Something went wrong", e);
                this.downloadLoading = false;
            }
        },
        formatCurrency,
        async createLongTask() {
            console.log("create long task now");

            let longTaskInput = new CashReportUserLongTaskInputData(this.exportType, this.transactionsFilterData as TransactionsFilterData);

            if (this.deviceTreeSelectedObjectItems && this.deviceTreeSelectedObjectItems.length) {
                longTaskInput.installationNames = this.deviceTreeSelectedObjectItems.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).map((c) => c.id);
                longTaskInput.folderIds = this.deviceTreeSelectedObjectItems.filter((c) => c.type == DeviceTreeNodeTypeEnum.Folder).map((c) => c.id);
            }

            await new CreateCashReportLongTaskCommand(longTaskInput).execute();

            this.longTaskDialog = false;

            router.replace(RR.UserPreferences);
        },

        exportClick(exportType) {
            if (this.exportWithLongTask) {
                this.hideExportType = true;
                this.exportType = exportType;
                this.longTaskDialog = true;
            } else {
                this.exportAs(exportType);
            }
        },
    },
});
